export default "__VITE_ASSET__Bl3ZJtOP__"